import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as jobStateSummaryActions from 'actions/jobStateSummaryActions';
import * as jobSummaryActions from 'actions/jobSummaryActions';
import JobStateNavigation from 'components/dashboard/JobStateNavigation';
import { Band, Header, HeaderButtonNav, HeaderButton } from 'components/layout';
import JobTableContainer from 'components/dashboard/JobTableContainer';
import OverlayModal from 'components/layout/OverlayModal';
import JobCreatorContainer from 'components/dashboard/JobCreatorContainer';
import { userCanAddJobs } from 'util/AdGroupsHelper';
import TableColumnsDropDown from './TableColumnsDropDown';

const DashboardPage = ({ actions, jobStateSummaries,location }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const { state, page, sort } = useParams();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    actions.getJobStateSummaries();
    getJobSummaries(state, {
      page: page ? parseInt(page) - 1 : 0,
      sort: sort,
    });
  }, [actions, state, page, sort]);  //will be called should any of these objects has been updated

  const getJobSummaries = (jobStateName, params) => {
    setLoaded(false);
  actions.getJobSummaries(jobStateName, params).then(() => setLoaded(true));
  };



  const getCurrentSort = () => {
   // let { match } = this.props;

   // if (match && match.params) {
      let sort1 = sort.split(',');
      //'modifieddate,DESC'
      return {
        name: sort1[0],
        order: sort1[1]
      };
    //}
    //return null;
  };

  const onHeaderClick =(column) => {
    const jobStateName = state;
    let sortOrder =
    sort?sort.split(',')[1]
        : null;
    sortOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC';
    const sortt = `${column.key},${sortOrder}`
    loadJobSummariesHeader({
      state: jobStateName,
      page: page,
      sort: sortt
    });
  };

  const loadJobSummariesHeader = (params) => {
    var pp = params.page;
    var ps = params.state;
    var psort = params.sort;
  
    getJobSummaries(ps, {
      page: pp ,
      sort: psort
    });
   // const routerAction = this.context.router.history.replace;
    //navigate(`/dashboard/${state}/${page}/${sort}`);
    navigate(`/dashboard/${ps}/${pp}/${psort}`);
   //handleChangePage(state,pp,sort)
  };

  const onPageChange = (page) => {
   // const { match } = this.props;
    const jobStateName = state;//match.params.state;
   
    loadJobSummaries({
      state: jobStateName,
      page: page,
      sort:sort //match.params.sort
    });
    navigate(`/dashboard/${jobStateName}/${page}/${sort}`);
  };

  const onRowClick = (row) => {
    const url =
      row.currentState === 'new'
        ? '/jobs/details/edit/' + row.id
        : '/jobs/' + row.id;
    navigate(url); // Use navigate from useNavigate
  };

  const toggleNavigation = () => {
    setShowOverlay((prev) => !prev);
  };

  const loadJobSummaries = (params) => {
    var pp = params.page;
    getJobSummaries(state, {
      page: pp?pp - 1:0,
      sort: sort
    });
   // const routerAction = this.context.router.history.replace;
    navigate(`/dashboard/${state}/${page}/${sort}`);
   //handleChangePage(state,pp,sort)
  };



  const jobStateChange = (jobState) => {
    const jobStateName = jobState.stateName.replace(' ', '-');
    const sort = `${jobState.defaultSortField},${jobState.defaultSortDirection}`;
    getJobSummaries(jobStateName, {
      page: 0,
      sort: sort,
    });
  };
  return (
    <div>
      <Header showLogo>
        <HeaderButtonNav>
          {userCanAddJobs() && (
            <HeaderButton color="primary" onClick={toggleNavigation} ligature="add" />
          )}
          <TableColumnsDropDown  params={state}/>
        </HeaderButtonNav>
        <JobStateNavigation
          jobStateSummaries={jobStateSummaries}
          onStateChange={jobStateChange}
         
        />
      </Header>
      <Band dark>
        {loaded ? (
          <JobTableContainer
          {...{ onRowClick, onPageChange, onHeaderClick, sort:{getCurrentSort},location }} />
         
        ) : (
          console.log('Loading...')
        )}
      </Band>
      <OverlayModal
        title="Create a new job"
        isOpen={showOverlay}
        toggle={toggleNavigation}
        wrapClassName="app-overlay"
      >
        <JobCreatorContainer />
      </OverlayModal>
    </div>
  );
};

function mapStateToProps(state,ownProps) {
  const location= ownProps.location;
  return {
    jobStateSummaries: state.jobStateSummaries,
    location:location
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...jobSummaryActions,
        ...jobStateSummaryActions,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
